import {BrowserModule} from '@angular/platform-browser';
import {DatePipe} from "@angular/common";
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RoutingModule} from './routing/routing.module';
import {NgZorroAntdModule, NzFormExplainComponent, NzFormItemDirective, NzModalService} from 'ng-zorro-antd';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppComponent} from './app.component';
import {ReactiveFormDemoComponent} from './components/reactive-form-demo/reactive-form-demo.component';
import {RegisterEnterpComponent} from './components/register-enterp/register-enterp.component';
import {HttpClientModule} from "@angular/common/http";
import {HttpCommonService} from "./services/http-common.service";
import {RouterModule} from "@angular/router";
import {LoginUserComponent} from "./components/login-user/login-user.component";
import {RegisterPersonalComponent} from "./components/register-personal/register-personal.component";
import {SearchParentComponent} from "./components/search-parent/search-parent.component";
import {HeaderComponent} from "./components/header/header.component";
import {FooterComponent} from "./components/footer/footer.component";
import {ThreeCascadeService} from "./services/three-cascade.service";
import {PageComponent} from "./components/page/page.component";
import {SearchService} from "./services/search.service";
import {EnterpMonitorComponent} from './components/enterp-monitor/enterp-monitor.component';
import {EnterpMonitorService} from "./services/enterp-monitor.service";
import {EnterpAtlasComponent} from "./components/enterp-atlas/enterp-atlas.component";
import {EnterpMapComponent} from './components/enterp-map/enterp-map.component';
import {EnterAssociationChainGraphComponent} from "./components/enter-association-chain-graph/enter-association-chain-graph.component";
import {EnterStockrightStructureComponent} from "./components/enter-stockright-structure/enter-stockright-structure.component";
import {EnterActualControlPersonComponent} from './components/enter-actual-control-person/enter-actual-control-person.component';
import {SearchBoxComponent} from "./components/search-box/search-box.component";
import {EnterpPortraitComponent} from './components/enterp-portrait/enterp-portrait.component';
import {PageService} from "./services/page.service";
import {NzDemoUploadBasicComponentComponent} from "./components/nz-demo-upload-basic-component/nz-demo-upload-basic-component.component";
import {Upload} from "./models/upload";
import {EnterpBasicArchivesComponent} from './components/enterp-basic-archives/enterp-basic-archives.component';
import {EnterpIntroductionComponent} from './components/enterp-introduction/enterp-introduction.component';
import {EnterpAtlasService} from "./services/enterp-atlas.service";
import {ObjectGeneration} from "./models/ObjectGeneration";
import {NgxEchartsModule} from 'ngx-echarts';
import {LoginFilter} from "./routing/LoginFilter";
import {User} from "./models/user";
import {IndexComponent} from "./components/index/index.component";
import {EnterpIntroductionServiceService} from "./services/enterp-introduction-service.service";

import {DataScreenComponent} from './components/data-screen/data-screen.component';
import {AccessIntereptor} from "./interceptor/accessIntereptor";
import {GlobalService} from "./services/global.service";
import {CookieService} from "ngx-cookie-service";
import {AttentionGroupService} from "./services/attention-group.service";
import {TabChangeService} from "./services/tab-change.service";
import {ShortMessageService} from "./services/short-message.service";
import {RegisterEnterpService} from "./services/register-enterp.service";
import {DataScreenService} from "./services/data-screen.service";
import {EnterpPortraitService} from "./services/enterp-portrait.service";
import {LoginService} from "./services/login.service";
import {EnterpGuard} from "./guard/EnterpGuard";
import {PaymentService} from "./services/payment.service";
import {EnterpSentimentPreviewComponent} from "./components/enterp-sentiment-preview/enterp-sentiment-preview.component";
import {CityListComponent} from './components/city-list/city-list.component';
import {CityDetailComponent} from './components/city-detail/city-detail.component';
import {PersonGuard} from "./guard/PersonGuard";
import {EnterpOemGuard} from "./guard/EnterpOemGuard";
import {SafeHtmlPipe} from "./pipe/SafeHtmlPipe";
import {LoginGuard} from "./guard/LoginGuard";
import {LocalStorage} from "./services/local.storage";
import {EnterCertifitionListService} from "./services/enter-certification-list.service";
import {MyQueryHistoryService} from "./services/my-query-history.service";
import {SuperviseService} from "./services/supervise.service";
import {CheckMapGuard} from "./guard/checkMapGuard";
import {CheckCreditGuard} from "./guard/checkCreditGuard";
import {CheckMonitorGuard} from "./guard/checkMonitorGuard";
import {CheckRatingGuard} from "./guard/checkRatingGuard";
import {CheckSuperviseGuard} from "./guard/checkSuperviseGuard";
import {SafeResourceUrlPipe} from './pipe/safe-resource-url.pipe';
import {LoginModalComponent} from './components/login-modal/login-modal.component';
import {CaptchaService} from "./services/captcha.service";
import {CaptchaComponent} from './components/captcha/captcha.component';
import {CityEnterApplyComponent} from './components/city-enter-apply/city-enter-apply.component';
import {CityReportApplyComponent} from './components/city-report-apply/city-report-apply.component';
import {CityCreditComponent} from './components/city-credit/city-credit.component';
import {CityCreditDetailComponent} from './components/city-credit-detail/city-credit-detail.component';
import {CityCreditService} from "./services/city-credit.service";
import {CitylistcreditComponent} from './components/citylistcredit/citylistcredit.component';
import {CityCreditNavComponent} from './components/city-credit-nav/city-credit-nav.component';
import {CreditVideoComponent} from './components/credit-video/credit-video.component';
import {PdfViewComponent} from './components/pdf-view/pdf-view.component';
import {PopBoxComponent} from "./components/pop-box/pop-box.component";
import {BadGuard} from "./guard/BadGuard";
import {PayGuard} from "./guard/PayGuard";
import {CheckJGUserGuard} from "./guard/checkJGUser";
import {EnterpEmployeesComponent} from './components/enterp-employees/enterp-employees.component';
import {EnterpNewsInfoComponent} from './components/enterp-news-info/enterp-news-info.component';
import {GzEcommerceSearchComponent} from './components/gz-ecommerce-search/gz-ecommerce-search.component';
import {GzLogisticsSearchComponent} from './components/gz-logistics-search/gz-logistics-search.component';
import {GDLoginGuard} from "./guard/GDLoginGuard";
import {BigCreditComponent} from "./components/big-credit/big-credit.component";
import {BigCreditDetailComponent} from "./components/big-credit-detail/big-credit-detail.component";
import {BigCreditNavComponent} from "./components/big-credit-nav/big-credit-nav.component";
import {PermissionComparisonComponent} from "./components/permission-comparison/permission-comparison.component";
import {ProtocolMsgComponent} from './components/protocol-msg/protocol-msg.component';
import {GDProtocolGuard} from "./guard/GDProtocolGuard";
import {InformationListComponent} from './components/information-list/information-list.component';
import { InformationDetailComponent } from './components/information-detail/information-detail.component';
import {GDIndexGuard} from "./guard/GDIndexGuard";


@NgModule({
  entryComponents:[CaptchaComponent],
  declarations: [
    AppComponent,
    RegisterEnterpComponent,
    ReactiveFormDemoComponent,
    LoginUserComponent,
    RegisterPersonalComponent,
    SearchParentComponent,
    HeaderComponent,
    FooterComponent,
    EnterpAtlasComponent,
    EnterpMapComponent,
    EnterAssociationChainGraphComponent,
    EnterStockrightStructureComponent,
    EnterActualControlPersonComponent,
    SearchBoxComponent,
    EnterpPortraitComponent,
    PageComponent,
    NzDemoUploadBasicComponentComponent,
    EnterpBasicArchivesComponent,
    EnterpIntroductionComponent,
    EnterpMonitorComponent,
    IndexComponent,
    IndexComponent,
    DataScreenComponent,
    EnterpSentimentPreviewComponent,
    CityListComponent,
    CityDetailComponent,
    SafeHtmlPipe,
    SafeResourceUrlPipe,
    LoginModalComponent,
    CaptchaComponent,
    CityEnterApplyComponent,
    CityReportApplyComponent,
    CityCreditComponent,
    CityCreditDetailComponent,
    CitylistcreditComponent,
    CityCreditNavComponent,
    CreditVideoComponent,
    PdfViewComponent,
    BigCreditComponent,
    BigCreditDetailComponent,
    BigCreditNavComponent,
    PopBoxComponent,
    EnterpEmployeesComponent,
    EnterpNewsInfoComponent,
    PermissionComparisonComponent,
    GzEcommerceSearchComponent,
    GzLogisticsSearchComponent,
    ProtocolMsgComponent,
    InformationListComponent,
    InformationDetailComponent
  ],

  imports: [
    BrowserModule,
    HttpClientModule,
    RoutingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxEchartsModule,
    NgZorroAntdModule.forRoot()
  ],
  providers: [
    PageService,
    HttpCommonService,
    SearchService,
    ThreeCascadeService,
    EnterpMonitorService,
    NzModalService,
    Upload,
    EnterpAtlasService,
    ObjectGeneration,
    LoginFilter,
    User,
    MyQueryHistoryService,
    NzFormItemDirective,
    SuperviseService,
    NzFormExplainComponent,
    AccessIntereptor,
    /*{
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },*/
    CookieService,
    GlobalService,
    CaptchaService,
    EnterpIntroductionServiceService,
    AttentionGroupService,
    TabChangeService,
    ShortMessageService,
    RegisterEnterpService,
    DataScreenService,
    EnterpPortraitService,
    EnterpGuard,
    EnterpOemGuard,
    LoginService,
    PaymentService,
    PersonGuard,
    LoginGuard,
    LocalStorage,
    CheckMapGuard,
    CheckCreditGuard,
    CheckMonitorGuard,
    CheckRatingGuard,
    CheckSuperviseGuard,
    EnterCertifitionListService,
    CityCreditService,
    DatePipe,
    BadGuard,
    PayGuard,
    CheckJGUserGuard,
    GDIndexGuard,
    GDLoginGuard,
    GDProtocolGuard,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/app.module.ts